import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_rmanzshebs: FaireBrandEntity = {
  token: "b_rmanzshebs",
  type: "brand",
  name: "Caden Lane",
  avatarUrl:
    "https://cdn.faire.com/fastly/21d0a07e822d4d3077471b2f4e654c02399fd44285a4b356376937e0f964dce3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b9cb0269cd96ff54f52fbd7ff2d08e92f6c86a4364b1570efa141991c4dcd69f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/21d0a07e822d4d3077471b2f4e654c02399fd44285a4b356376937e0f964dce3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b9cb0269cd96ff54f52fbd7ff2d08e92f6c86a4364b1570efa141991c4dcd69f.jpeg",
  location: "Boerne, TX, USA",
  minimumOrderDollars: 1000,
  rating: 4.9,
  reviewCount: 18,
  isInsider: true,
  description:
    "At Caden Lane, we believe babyhood deserves better. Better fabrics, better fits, and better style for the tiniest humans and the incredible moms who care for them. Born from a deep love for design and an even deeper love for motherhood, Caden Lane has grown into a trusted destination for newborn essentials, buttery-soft pajamas, and thoughtfully crafted swimwear that keeps up with every moment of early childhood.\nWhat started with boutique nursery bedding quickly grew into a trusted name for parents everywhere. Today, Caden Lane is known for its buttery-soft newborn essentials, incredibly cozy pajamas, and thoughtfully designed swimwear that keeps up with every stage of childhood. Every piece is created with comfort, practicality, and modern style in mind, because new moms deserve to feel good about what they’re putting on their baby’s skin.\nFrom hospital bags to bedtime snuggles to first trips to the beach, Caden Lane has become a part of countless families’ most treasured moments. Katy’s passion for motherhood and eye for design continue to drive the brand forward, making Caden Lane more than just a product line, it’s a brand built by a mom who gets it.\n\n**All sales are subject to our MAAP & Online Agreement found here: https://cadenlane.com/pages/wholesale-maap-online-agreement\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:25.100Z",
    importedBy: "entity-db-cli",
  },
};
